import { isFeatureEnabled } from 'owa-feature-flags';
import { isBrowserIE } from 'owa-user-agent/lib/userAgent';

export function isGetStartedPhoneCardEnabled() {
    return isFeatureEnabled('getStarted-PhoneCard') && !isBrowserIE();
}
